import { Component, Input, OnInit } from '@angular/core';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { first } from 'rxjs/operators';

import { FundStatusInteractionGroupConfig } from '../../models/fund-status-interaction-config.interface';
import { FundStatusInteractions } from '../../models/fund-status-interaction.interface';
import { FundStatusInteractionService } from '../../services/fund-status-interaction.service';

@Component({
	selector: 'fund-stats-interaction-menu',
	templateUrl: './fund-status-interaction-menu.component.html',
	styleUrls: ['./fund-status-interaction-menu.component.scss']
})
export class FundStatusInteractionMenuComponent implements OnInit {
	@InjectConfig(SharedConfigKey.SUPPORTED_FUND_STATUS_INTERACTIONS) public readonly supportedFundStatusInteractions: FundStatusInteractionGroupConfig[];

	@Input() public showHeader: boolean = false;
	@Input() public fundData; // TODO wkennerl: add type after moving to FundStatsModule

	@Input() public isSuggestedAddition: boolean;
	@Input() public displayStatus: boolean;
	@Input() public statusColour: string;
	@Input() public comparisonStatusColour: string;
	@Input() public statusChange: number; // 0 / 1 values expected, looking more into it if needed
	@Input() public initialInteractionId: string;
	@Input() public asOfDate: string;
	@Input() public asOfDateCompare: string;

	@Input() public closeCallback: () => void;
	@Input() public statusUpdateCallback: (statusInteraction: string) => void;

	public tooltipStatusIconSrc: string;
	public tooltipStatusComparisonIconSrc: string;
	public visible: boolean;
	public mode: 'table' | 'deep dive';

	public selectedInteractionId: string;

	constructor(public fundStatusInteractionService: FundStatusInteractionService) { }

	public ngOnInit(): void {
		if (this.displayStatus) {
			this.tooltipStatusIconSrc = `iq/status-${this.statusColour}-tooltip.svg`;

			if (this.statusChange) {
				this.tooltipStatusComparisonIconSrc = `iq/status-${this.comparisonStatusColour}-tooltip.svg`;
			}
		}

		this.mode = this.showHeader ? 'table' : 'deep dive'; // used for tracking purposes
		this.visible = false;
		this.selectedInteractionId = this.initialInteractionId ?? 'default';
	}

	public onRadioClick(interactionId: string) {
		this.selectedInteractionId = interactionId;
	}

	public onApply(): void {
		// This makes sure that if an error is thrown while setting the tags and before updating the store, the menu will still close
		this.closeCallback();

		if (this.initialInteractionId !== this.selectedInteractionId) {
			const clientId = this.fundData.clientId.formattedValue;
			const interactionsToUpdate: FundStatusInteractions = {
				[clientId]: {
					id: clientId,
					interactionType: this.selectedInteractionId,
					status: this.statusColour,
					clientId,
					morningstarSecId: this.fundData.morningstarSecId.formattedValue,
					cusip: this.fundData.cusip.formattedValue,
					ticker: this.fundData.ticker.formattedValue,
					isBlkFund: this.fundData.isBlkFund.rawValue
				}
			};

			this.fundStatusInteractionService.setFundStatusInteractions(interactionsToUpdate).pipe(first()).subscribe();

			if (this.statusUpdateCallback) {
				this.statusUpdateCallback(this.selectedInteractionId);
			}
		}
	}
}
